<template>
  <section v-if="!loading" class="termination">
    <div class="row">
      <div class="col-lg-4">
        <policy-search-panel
          :filter="filter"
          :form="form"
          :can-search="searchDisabledBtn"
          @update:filter="filter = $event"
          @update:form="form = $event"
          @search="searchPolicy"
          @clear="clearForm"
        />
      </div>
      <div class="col-lg-8">
        <policy-history-table v-if="!results" :history="history" @page-change="getHistory">
          <template #actions="{ index }">
            <i @click="openModal(1, index)" class="ki-outline ki-right-square text-primary fs-4 cursor-pointer"></i>
          </template>
        </policy-history-table>
        <policy-search-results-table v-else :results="results">
          <template #actions="{ item, index }">
            <i
              v-if="canOpenResultModal(item)"
              @click="openModal(2, index)"
              class="ki-outline ki-right-square text-primary fs-4 cursor-pointer"
            ></i>
          </template>
        </policy-search-results-table>
      </div>
    </div>
  </section>
  <loader-full v-else />
  <termination-policy-modal v-if="terminationPolicyModalShow && changeData" :policy="changeData" :policy-type="changeDataType" @reload="reload" />
</template>

<script>
// Modal
import TerminationPolicyModal from '@/components/Modals/Functional/TerminationPolicyModal'
// Other
import LoaderFull from '@/components/Main/LoaderFull'
import PolicySearchPanel from '@/components/Functional/PolicySearchPanel'
import PolicyHistoryTable from '@/components/Functional/PolicyHistoryTable'
import PolicySearchResultsTable from '@/components/Functional/PolicySearchResultsTable'
import axios from 'axios'

const createDefaultForm = () => ({
  iin: '',
  contract: '',
  surname: '',
  name: '',
  birthday: '',
  vehicle: ''
})

export default {
  name: 'TerminationView',
  components: {
    LoaderFull,
    TerminationPolicyModal,
    PolicySearchPanel,
    PolicyHistoryTable,
    PolicySearchResultsTable
  },
  data() {
    return {
      functionalType: 5,
      loading: false,
      searchDisabledBtn: false,
      changeData: null,
      changeDataType: null,
      filter: {
        product: 1,
        type: 2
      },
      form: createDefaultForm(),
      history: null,
      results: null
    }
  },
  computed: {
    terminationPolicyModalShow() { return this.$store.state.terminationPolicyModalShow },
  },
  mounted() {
    this.getHistory()
  },
  methods: {
    reload() {
      this.clearForm()
      this.getHistory()
    },
    clearForm() {
      this.filter = { ...this.filter, type: 1 }
      this.form = createDefaultForm()
      this.results = null
    },
    getHistory(page = 1) {
      this.loading = true
      axios.get('api/contracts/functional/history?page=' + page + '&type=' + this.functionalType)
          .then(res => {
            this.history = res.data
          })
          .catch(err => { console.log(err) })
          .finally(() => this.loading = false)
    },
    searchPolicy() {
      this.loading = true
      axios.post('api/contracts/functional/contracts', this.form)
          .then(res => {
            if (res.data.result) {
              this.results = res.data.data
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => this.loading = false)
    },
    validateFormForSearch(form, type) {
      switch (type) {
        case 1:
          return form.contract.length > 0
        case 2:
          return form.iin.length === 12
        case 3:
          return form.surname.length > 0 && form.name.length > 0 && form.birthday.length && form.vehicle.length > 0
        default: return false
      }
    },
    canOpenResultModal(item) {
      return item && ((item.status?.code === '3' || item.status?.code === 3) || (item.status?.code === '2' || item.status?.code === 2))
    },
    openModal(type, key) {
      if (type && key !== null) {
        const data = type === 1 ? this.history.data : this.results
        this.changeData = data[key]
        this.changeDataType = type
        this.$store.commit('setTerminationPolicyModalShow', true);
        setTimeout(() => {new window.bootstrap.Modal('#terminationPolicyModal').show()}, 10)
      }
    }
  },
  watch: {
    'filter.type': {
      immediate: true,
      handler() {
        this.form = createDefaultForm()
      }
    },
    form: {
      deep: true,
      handler(val) {
        this.searchDisabledBtn = this.validateFormForSearch(val, this.filter.type)
      }
    }
  }
}
</script>

<style>

</style>